import { Component, EventEmitter, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DwMediaRepositoryService } from '@devwareapps/devware-cap';
import { CourseLessonEntity, CourseLessonProgressEntity, QuizEntity, QuizResultEntity, QuizResultStatusAllItems } from '../../../../../meta-data/app-meta-data.service';
import { DateTimeUtilService } from 'src/app/features/shared/util/date-time-util.service';
import { QuizValidationResult } from '../../../models/quiz-validation-result.model';

@Component({
  selector: 'app-quiz-card',
  templateUrl: './quiz-card.component.html',
  styleUrls: ['./quiz-card.component.scss']
})
export class QuizCardComponent implements OnInit, OnChanges {

  cardConfig?: any;
  @Input() data?: CourseLessonEntity;
  @Input() quiz?: QuizEntity;
  @Input() lessonProgress?: CourseLessonProgressEntity;
  @Input() quizResults: QuizResultEntity[] = [];
  resolvedContext?: any;
  cardClick: EventEmitter<any> = new EventEmitter<any>();

  @Input() quizValidationResult: QuizValidationResult;

  imageUrl: string = '';
  defaultImageUrl: string = '/assets/aviator-online/img/quiz-image-default.png';
  progressPercent = 0;
  timeLimit: string;
  passFailPercentValue: string;
  passFailRatio: string;
  maxAttempts: string;
  maxQuestions: string;
  constructor(private dwMediaRepository: DwMediaRepositoryService, private dateTimeUtilService: DateTimeUtilService) { }
  
  ngOnInit(): void {
    this.setupCard();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setupCard();
  }

  setupCard() {
    if (!this.data) {
      this.quiz = null;
      this.timeLimit = null;
      return;
    }

    this.quiz = this.data.Quiz;

    if (!this.quiz) {
      this.timeLimit = null;
      return;
    }

    this.timeLimit = this.quiz.TimeLimitMinutes
      ? this.dateTimeUtilService.formatDuration2(this.quiz.TimeLimitMinutes * 60)
      : null;

    this.maxQuestions = this.quiz.MaxQuestionsToShow != null
      ? `${this.quiz.MaxQuestionsToShow}`
      : null;

    if (this.data?.LessonImageDwroMedia?.MediaPath) {
      this.imageUrl = `${this.dwMediaRepository.mediaApi}/download/${this.data.LessonImageDwroMedia.MediaPath}`;
    }

    this.passFailPercentValue = null;
    this.passFailRatio = null;

    const completedAttemptCount = this.lessonProgress?.CompletedQuizAttemptCount;
    const passedAttemptCount = this.lessonProgress?.PassedQuizAttemptCount;
    const activeQuizResults = this.quizResults?.filter(result =>
      result.QuizResultStatusId === QuizResultStatusAllItems.Passed
      || result.QuizResultStatusId === QuizResultStatusAllItems.Failed) ?? [];
    const quizAttempts = completedAttemptCount != null ? completedAttemptCount : activeQuizResults.length;
    const quizPasses = passedAttemptCount != null
      ? passedAttemptCount
      : activeQuizResults.filter(result => result.QuizResultStatusId === QuizResultStatusAllItems.Passed).length;

    if (quizAttempts > 0) {
      const passFailPercent = Math.round((quizPasses * 100) / quizAttempts);

      this.passFailPercentValue = `${passFailPercent}%`;
      this.passFailRatio = `(${quizPasses}/${quizAttempts})`;
    }

    if (this.quizValidationResult?.MaxFailedQuizAttempts && this.quizValidationResult?.ClearProgressAfterFailedAttempts) {
      this.maxAttempts = `${this.quizValidationResult.MaxFailedQuizAttempts}`;

      // if (this.quizValidationResult.RemainingQuizAttempts == 1) {
      //   this.maxAttempts += ', 1 attempt remaining';
      // } else {
      //   this.maxAttempts += `, ${this.quizValidationResult.RemainingQuizAttempts} attempts remaining`;
      // }
    }
  }

  click() {

  }

}
